import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { LlmBlock, useLlmView } from '@websolutespa/bom-mixer-llm';
import style from './custom-card.module.scss';

export type LlmChunkCustomCard = {
  type: 'customCard';
  id: string;
  title?: string;
  abstract?: string;
  media?: {
    type: 'image';
    url: string;
  };
  href?: string;
};

export const CustomCard: React.FC<LlmBlock<LlmChunkCustomCard>> = (props) => {
  const { item } = props;
  const label = useLabel();
  const { send } = useLlmView(state => state.actions);
  const onTellMeMore = async (event: React.MouseEvent) => {
    const prompt = `${label('llm.tellMeMoreAbout')} ${item.title}`;
    await send(prompt, (response) => {
      // console.log('Prompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('Prompt.onEnd', response);
    });
  };
  const ariaLabel = label('llm.tellMeMore');
  return (
    <div className={style.customCard}>
      {item.media && (
        <>
          {item.href ? (
            <a className={style.customCardMedia} href={item.href} target="_blank" rel="noreferrer" aria-label={ariaLabel}>
              <div className={style.customCardAsset}>
                <img src={item.media.url} alt="" />
              </div>
            </a>
          ) : (
            <div className={style.customCardMedia}>
              <div className={style.customCardAsset}>
                <img src={item.media.url} alt="" />
              </div>
            </div>
          )}
        </>
      )}
      <div className={style.customCardContent}>
        {item.title && (
          <div className={style.customCardTitle} dangerouslySetInnerHTML={{ __html: item.title }} />
        )}
        {item.abstract && (
          <div className={style.customCardAbstract} dangerouslySetInnerHTML={{ __html: item.abstract }} />
        )}
        <a className="llm__cta llm__cta--button llm__cta--link" href={item.href} target="_blank" rel="noreferrer">
          <span>{label('llm.discoverProduct')}</span>
        </a>
        {/* <Cta type="button" className={style.customCardButton} label={label('llm.discoverProduct')} onClick={onTellMeMore} /> */}
      </div>
    </div>
  );
};

